import { render, staticRenderFns } from "./CoinSettings.vue?vue&type=template&id=453796e8&scoped=true&"
import script from "./CoinSettings.vue?vue&type=script&lang=js&"
export * from "./CoinSettings.vue?vue&type=script&lang=js&"
import style0 from "./CoinSettings.vue?vue&type=style&index=0&id=453796e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453796e8",
  null
  
)

export default component.exports